import { useAppDispatch } from '../store'
import { useSaveToken } from '../store/settings/hooks'
import { useWeb3React } from '@web3-react/core'
import { useLinkConnected } from '../store/link/hooks'
import authorization from '../utils/authorization'
import { updateUserToken } from '../store/account/actions'
import { useEffect } from 'react'
import { useConnectZkex } from './useConnectZkex'

export function useRestoreZkexConnection() {
  const dispatch = useAppDispatch()
  const isSaveToken = useSaveToken()
  const { provider, account } = useWeb3React()
  const connected = useLinkConnected()
  const connectZkex = useConnectZkex()
  const restoreAccount = async () => {
    // When the user turns on the storage web3 settings
    // Check if there is relevant data in storage
    if (!isSaveToken) return
    if (!account) return
    if (!provider) return
    if (connected) return

    // If has the user's authorization data in the local storage
    // Then use the authorization data to restore the user's account
    if (authorization.has(account)) {
      dispatch(updateUserToken(authorization.get(account)!))
    }

    connectZkex()
  }
  useEffect(() => {
    restoreAccount()
  }, [isSaveToken, account, connected, provider])
}
